/**
*	 cgiReporter.js
*	 返回码上报组件
*	@desc 返回码上报组件，直接上报到罗盘上面
*	@author: liamhuang
*	@date: 20160522
*/



var http_img_sender = function () {
    var img = new Image();
    var sender = function (reportParam) {

        var paramArr = [];
        for (var i in reportParam) {
            paramArr.push(i + "=" + encodeURIComponent(reportParam[i]));
        }

        return;

        var url = "//report.vip.qq.com/cgi-bin/report?r=reportData/doReport&tbName=dc01066&t=" + Math.random() + "&" + paramArr.join("&");

        var _send = function () {
            img.onload = img.onerror = img.onabort = function () {
                img.onload = img.onerror = img.onabort = null;
                img = null;
            };
            img.src = url;
        };

        _send();
    };

    return sender;
};

/**
* 解析url，返回组成部分
* @param {string} url url
* @return {object} 组成部分，参考window.location
* @example
* parseUrl('http://www.qq.com:80/?name=value#hash') : {
*     hash: "#hash",
*     host: "www.qq.com",
*     hostname: "www.qq.com",
*     href: "http://www.qq.com/?name=value#hash",
*     pathname: "/",
*     port: "80",
*     protocol: "http:",
*     search: "?name=value"
* };
*/
var parseUrl = function (url) {
    if (/^(([^:\/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/.test(url)) {
        var host = RegExp.$4.split(':');
        return {
            protocol: RegExp.$1,
            host: RegExp.$4,
            hostname: host[0],
            port: host[1] || '',
            pathname: RegExp.$5,
            search: RegExp.$6,
            hash: RegExp.$8,
            href: url
        };
    } else {
        return null;
    }
};

var getCurPageUrl = function () {   //因为目前的控制台有很多采用的是多级，参数会放在url中。所以，需要对页面进行区分.
    var path = window.location.pathname || "";
    var host = window.location.host || "";

    var arr = path.split("/");
    var finalArr = [];
    finalArr.push(host);
    for (var i = 1; i < Math.min(3, arr.length); i++) {
        finalArr.push(arr[i]);
    }

    return finalArr.join("/");  //最多取前两级
};

/**
 * 上报 CGI 状况
 *
 * @method cgi
 * @param {object} param 上报的 CGI 信息
 *    - param.url {string} CGI的地址，会对地址进行处理
 *    - param.code   {number} CGI 返回码
 *    - param.time   {number} CGI 耗时
 *	  - param.succMap{object} 可选  code是成功的还是失败的，先查询这个结构里面，如果没有的话，就按照0成功，非0失败的原则处理
 *    - param.opt    {object} 附加参数，这些参数会被统一按照附加的放进去。目前附加的支持
 *		ext2-ext10
 *
 * */
var report = function (param) {
    if (!param || typeof (param) != 'object' || !param.url) {
        return;
    }

    param.opt = param.opt || {};
    param.succMap = param.succMap || {};

    var cgi = parseUrl(param.url);
    var pageOBj = parseUrl(window.location.href);

    //对param进行处理
    var data = {
        url: param.url,   //用户的cgi全地址
        domain: cgi.host || window.location.host,
        cgi: cgi.pathname,
        page: getCurPageUrl(),
        type: param.succMap[param.code] ? 1 : (0 == param.code ? 1 : 2),  //1成功 ，2 失败 ,3逻辑失败
        code: param.code,
        time: param.time
    };


    for (var i in param.opt) {  //将opt中的数据复制过来，统一上报
        data[i] = param.opt[i];
    }


    var sender = http_img_sender();
    sender(data);
};


export default report;